import * as tslib_1 from "tslib";
import { OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import { getDistance } from 'geolib';
import gql from 'graphql-tag';
import { chain } from 'lodash';
import { sentry } from 'sentry';
import { FcSearchInputComponent } from '../../base/fc-search-input/fc-search-input.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchCompanies(\n    $where: CompanyWhereInput\n    $orderByDistance: CompanyOrderByDistanceInput\n  ) {\n    companies(\n      where: $where\n      orderByDistance: $orderByDistance\n      orderBy: name_asc\n      limit: 1000\n      offset: 0\n    ){\n      items {\n        id\n        name\n        avatarUrl\n        createdAt\n        archived\n        address {\n          coords {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query searchCompanies(\n    $where: CompanyWhereInput\n    $orderByDistance: CompanyOrderByDistanceInput\n  ) {\n    companies(\n      where: $where\n      orderByDistance: $orderByDistance\n      orderBy: name_asc\n      limit: 1000\n      offset: 0\n    ){\n      items {\n        id\n        name\n        avatarUrl\n        createdAt\n        archived\n        address {\n          coords {\n            latitude\n            longitude\n          }\n        }\n      }\n    }\n  }\n"])));
var FcCompanyInputComponent = /** @class */ (function () {
    function FcCompanyInputComponent(apollo, translateService, fuseTranslationLoaderService) {
        this.apollo = apollo;
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.compareWithCoords = null;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = true;
        this.searchOnFocus = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcCompanyInputComponent.prototype.resetSearch = function () {
        this.searchInput.resetSearch();
    };
    FcCompanyInputComponent.prototype.ngOnChanges = function (changes) {
        if (changes.compareWithCoords && changes.compareWithCoords.currentValue && this.control.value) {
            this.displayText = this.displayWith(this.control.value);
        }
    };
    FcCompanyInputComponent.prototype.search = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                name_contains: searchTerm,
                                archived: false
                            },
                            orderByDistance: this.compareWithCoords && {
                                direction: 'asc',
                                distance: {
                                    latitude: Number(this.compareWithCoords.latitude),
                                    longitude: Number(this.compareWithCoords.longitude)
                                }
                            }
                        }
                    })
                        .toPromise()
                        .then(function (result) {
                        var items = result.data['companies'].items;
                        return _this.sortCompanies(items);
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcCompanyInputComponent.prototype.displayWith = function (value) {
        try {
            var address = value.address;
            if (this.compareWithCoords && address && address.coords.latitude && address.coords.longitude) {
                var distanceInMeters = getDistance(this.compareWithCoords, address.coords);
                var distanceFromMaintenance = this.translateService.instant('COMPANY.DISTANCE', {
                    distance: (distanceInMeters / 1000).toFixed(2).replace('.', ',')
                });
                return value.name + " - (" + distanceFromMaintenance + ")";
            }
            return value.name;
        }
        catch (_a) {
            return null;
        }
    };
    FcCompanyInputComponent.prototype.sortCompanies = function (items) {
        var _this = this;
        if (!this.compareWithCoords) {
            return items;
        }
        return chain(items)
            .map(function (item) { return (tslib_1.__assign({}, item, { distance: item.address.coords.latitude && item.address.coords.longitude && getDistance(_this.compareWithCoords, item.address.coords) })); })
            .value();
    };
    return FcCompanyInputComponent;
}());
export { FcCompanyInputComponent };
var templateObject_1;
